export default "__VITE_ASSET__Bm6W9oJg__"